import {
	instance
} from "../api/index";
import store from "@/store/index"
import Qs from 'qs'
let apiUrl = process.env.BASE_URL //接口请求的域名
let token = {}
// let userId = store.state.userInfo.id || 2 


if (store.state.token) {
	token = {
		token: store.state.token
	}
}

export function get(url, data = {}) {
	return instance({
		method: "get",
		url: apiUrl + url,
		params: data
	})
}

export function post(url, data = {}) {
	return instance({
		method: "post",
		url: apiUrl + url,
		data: Qs.stringify(data),
		// data: Qs.parse(data)
	})
}

export function $post(url, data = {}) {
	let userId = store.state.userInfo ? store.state.userInfo.id: null
	let params = {
		...data
	}
	if (userId) {
		params = {
			...params,
			userId
		}
	}
	return instance({
		method: "post",
		url: apiUrl + url,
		data: {
			...params
		},
		headers: {
			'Content-Type': 'application/json'
		}
	})
}



// WEBPACK FOOTER //
// ./src/api/methods.js